import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

const rootElement = document.getElementById("cotizador_root");
const legalUrl = document.getElementById("legal_url");
const modelUrl = document.getElementById("model_url");
const contactUrl = document.getElementById("contact_url");

if (legalUrl && modelUrl) {
//    const price_list = rootElement.dataset.pricelist;
    const legal_url = legalUrl.dataset.legalurl;
    const model_url = modelUrl.dataset.modelurl;
    const contact_url = contactUrl ? contactUrl.dataset.contacturl : null;
    const car_id = rootElement.dataset.car ? parseInt(rootElement.dataset.car) : null;

    ReactDOM.render(
        <App
            //price_list={price_list}
            legal_url={legal_url}
            model_url={model_url}
            contact_url={contact_url}
            car_id={car_id}
        />,
        rootElement
    );
}